import { addPasswordRoute } from "./add-password/route";
import {
  askPunttChatCanvasRoute,
  askPunttChatReviewCommentRoute,
  askPunttChatReviewRoute,
  askPunttProjectChatDeepLinkRoute,
  askPunttProjectReviewCommentRoute,
  askPunttProjectReviewRoute,
} from "./ask-puntt/askPunttDeepLinkRoutes";
import { campaignRoute } from "./ask-puntt/campaignRoute";
import {
  askPunttCampaignRedirectRoute,
  askPunttCampaignsRedirectRoute,
} from "./ask-puntt/campaignsRedirectRoutes";
import { askPunttChatRoute } from "./ask-puntt/chatRoute";
import { askPunttChatsRoute } from "./ask-puntt/chatsRoute";
import { askPunttProjectsRoute } from "./ask-puntt/projectsRoute";
import { askPunttRoute } from "./ask-puntt/route";
import { askPunttStreamingTestRoute } from "./ask-puntt/streamingTestRoute";
import { askPunttStyleGuideRoute } from "./ask-puntt/styleGuideRoute";
import { authLayoutRoute } from "./auth-layout/route";
import { errorRoute } from "./error/route";
import { forgotPasswordRoute } from "./forgot-password/route";
import { indexRoute } from "./index/route";
import { processRoute } from "./intro/process";
import { resultsRoute } from "./intro/results";
import { startRoute } from "./intro/start";
import { loginRoute } from "./login/route";
import { logoutRoute } from "./logout/route";
import { privacyPolicyRoute } from "./privacy-policy/route";
import { resetPasswordRoute } from "./reset-password/route";
import { roiRoute } from "./roi/route";
import { auditLogRoute } from "./roi/routes/audit-log/route";
import { settingsRoute } from "./settings/route";
import { archivedUsersRoute } from "./settings/routes/archivedUsersRoute";
import { enterpriseSettingsRoute } from "./settings/routes/enterpriseSettingsRoute";
import { integrationSettingsRoute } from "./settings/routes/integrationSettingsRoute";
import { knowledgeDatabaseRoute } from "./settings/routes/knowledge-database/route";
import { knowledgeSettingRoute } from "./settings/routes/knowledgeSettingRoute";
import { notificationsSettingsRoute } from "./settings/routes/notificationsSettingsRoute";
import { usersRoute } from "./settings/routes/usersRoute";
import { warholOutputGuidanceRoute } from "./settings/routes/warholOutputGuidanceRoute";
import { ticketsRoute } from "./tickets/route";
import { chromeExtensionRoute } from "./tickets/routes/chrome-extension";
import { figmaPluginRoute } from "./tickets/routes/figma-ticket";
import { ticketRoute } from "./tickets/routes/ticket/route";
import { ticketCommentRoute } from "./tickets/routes/ticket_comment";
import { ticketCompatibilityRoute } from "./tickets/routes/ticket_compat";
import { unauthLayoutRoute } from "./unauth-layout/route";
import { vitaloraAgentsActivityRoute } from "./vitalora-agents/activityRoute";
import { vitaloraAgentsRoutingRoute } from "./vitalora-agents/routingRoute";
import { vitaloraHomeRoute } from "./vitalora-home/route";
import { vitaloraIntegrationsRoute } from "./vitalora-integrations/route";

export { rootRoute } from "./root/route";
export const appRoutes = [
  startRoute,
  processRoute,
  resultsRoute,
  indexRoute,
  privacyPolicyRoute,
  authLayoutRoute.addChildren([
    addPasswordRoute,
    ticketsRoute.addChildren([
      ticketCommentRoute,
      ticketCompatibilityRoute,
      ticketRoute,
    ]),
    settingsRoute,
    enterpriseSettingsRoute,
    knowledgeSettingRoute,
    warholOutputGuidanceRoute,
    knowledgeDatabaseRoute,
    integrationSettingsRoute,
    notificationsSettingsRoute,
    usersRoute,
    archivedUsersRoute,
    figmaPluginRoute,
    errorRoute,

    chromeExtensionRoute,

    // ROI Routes
    roiRoute,
    auditLogRoute,

    // Ask Puntt Routes
    askPunttRoute,
    askPunttProjectsRoute,
    askPunttProjectReviewRoute,
    askPunttProjectReviewCommentRoute,
    askPunttProjectChatDeepLinkRoute,
    askPunttChatReviewRoute,
    askPunttChatReviewCommentRoute,
    askPunttChatCanvasRoute,
    campaignRoute,
    askPunttCampaignsRedirectRoute,
    askPunttCampaignRedirectRoute,
    askPunttChatsRoute,
    askPunttChatRoute,
    askPunttStyleGuideRoute,
    askPunttStreamingTestRoute,

    // Vitalora demo routes (gated to demo enterprise via beforeLoad)
    vitaloraHomeRoute,
    vitaloraAgentsActivityRoute,
    vitaloraAgentsRoutingRoute,
    vitaloraIntegrationsRoute,
  ]),
  unauthLayoutRoute.addChildren([
    loginRoute,
    forgotPasswordRoute,
    resetPasswordRoute,
  ]),
  logoutRoute,
];
